import { graphql } from "gql";

const RETRY_JOB_MUTATION = graphql(`
  mutation RetryJob($id: ID!) {
    retryJob(id: $id) {
      ...Job
    }
  }
`);

export default RETRY_JOB_MUTATION;
